import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const AzureSynapse = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="AzureSynapse"
    height={height}
    width={width}
    title="Azure Synapse logo"
    titleId="azure-synapse-logo-title"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      d="M24.0616 1L4 12.4702V31.0999V32.323V35.3956L24.0616 47L44.1232 35.5298V12.5298L24.0616 1ZM40.4241 33.1284L24.0616 42.585L7.69909 33.2328V17.9144V14.7821V14.7374L24.0616 5.2808L40.4241 14.7672V33.1284Z"
      fill="#0078D1"
    />
    <path
      d="M31.9655 24.0002C31.6373 24.0002 31.3241 24.03 31.0258 24.0897C28.6691 21.0469 25.1937 19.0183 21.3753 18.4814L37.9168 8.92041L34.0686 6.71289L18.9441 15.4535C18.1685 14.8867 17.1989 14.5436 16.1548 14.5436C13.5446 14.5436 11.4266 16.6617 11.4266 19.2719C11.4266 21.8822 13.5446 24.0002 16.1548 24.0002C17.6613 24.0002 19.0187 23.2842 19.8838 22.1805C23.031 22.3595 25.9544 23.8809 27.8935 26.3121C27.4758 27.0131 27.2372 27.8335 27.2372 28.7135C27.2372 28.8776 27.2521 29.0566 27.267 29.2207L10.293 39.0352L14.1263 41.2427L29.1762 32.532C29.9519 33.0988 30.9214 33.4418 31.9655 33.4418C34.5757 33.4418 36.6937 31.3238 36.6937 28.7135C36.6937 26.1182 34.5757 24.0002 31.9655 24.0002Z"
      fill="#50E6FF"
    />
  </SvgIcon>
);
